import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useContentValue } from "../../ContentContext";

export const FeaturedIn = () => {
    const f = useContentValue("featured_in", {
        kicker: "Featured In",
        side_label: "Press",
        publication: "Simcoe.com",
        publication_meta: "Local Feature",
        quote: "Collingwood food truck Strake Sandwich Co. on a roll with its East Coast specialty.",
        supporting: "Recognized locally for gourmet sandwiches, loaded fries & East Coast–inspired flavors.",
        link_label: "Read Article",
        link_url: "https://www.simcoe.com/things-to-do/food-and-drink/all-deliciousness-collingwood-food-truck-strake-sandwich-co-on-roll-with-its-east-coast-specialty/article_5da06317-74c5-51cd-9415-a3673b31392d.html",
    });
    const pubParts = (f.publication || "").split(".");
    return (
        <section
            data-testid="featured-in-section"
            className="bg-[#EBE2D2] py-14 px-6 relative grain overflow-hidden"
        >
            <div className="flex items-center gap-3 mb-7">
                <div className="font-body text-[10px] uppercase tracking-[0.45em] font-bold text-[#1A1A1A]/70">
                    {f.kicker}
                </div>
                <div className="h-[1px] flex-grow bg-[#1A1A1A]/40" />
                <div className="font-body text-[10px] uppercase tracking-[0.4em] font-semibold text-[#1A1A1A]/50">
                    {f.side_label}
                </div>
            </div>

            <div className="flex items-center gap-3 mb-5">
                <div className="font-display uppercase text-[#1A1A1A] text-lg sm:text-xl tracking-[0.18em] font-bold">
                    {pubParts[0]}
                    {pubParts.length > 1 && <span className="text-[#C65A2C]">.</span>}
                    {pubParts.slice(1).join(".")}
                </div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#1A1A1A]/55 font-body italic">
                    {f.publication_meta}
                </div>
            </div>

            <blockquote className="relative">
                <div className="absolute -left-2 -top-3 text-[64px] leading-none text-[#C65A2C]/40 font-vintage select-none">
                    “
                </div>
                <p className="font-vintage text-[#1A1A1A] text-[24px] sm:text-[30px] leading-[1.15] tracking-tight relative pl-4">
                    {f.quote}
                </p>
            </blockquote>

            <p className="mt-6 font-body text-[13px] sm:text-sm text-[#1A1A1A]/75 italic leading-relaxed max-w-md">
                {f.supporting}
            </p>

            {f.link_url && (
                <a
                    data-testid="featured-article-link"
                    href={f.link_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 mt-8 border-b-2 border-[#1A1A1A] pb-1 font-display uppercase text-[12px] sm:text-sm tracking-[0.3em] font-bold text-[#1A1A1A] hover:text-[#C65A2C] hover:border-[#C65A2C] transition-colors"
                >
                    {f.link_label || "Read Article"}
                    <ArrowUpRight size={14} strokeWidth={2.2} />
                </a>
            )}

            <div className="mt-10 h-px bg-[#1A1A1A]/30" />
        </section>
    );
};
